// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3PWF7","header":"Card_header__eELW9","main":"Card_main__10EGY"};